/**
 * Created by robert.lavoie on 4/18/17.
 */

import { Component, Input } from '@angular/core';

// Models
import { SiteSection } from 'careerpages-base/models';


/**
 *
 * @class
 * CustomerSiteSectionComponent
 *
 *
 * @description
 * This component is purely a presentational component used to display a customer-site section
 *
 */
@Component({
  templateUrl: 'customer-site-section.component.html',
  selector: 'customer-site-section',
  styleUrls: ['./customer-site-section.component.scss'],
})
export class CustomerSiteSectionComponent {

  @Input() theme: object;
  @Input() section: SiteSection;
  @Input() columnCount: number;

}
